import { render, staticRenderFns } from "./wonderfulPVTitle.vue?vue&type=template&id=1639a948&scoped=true"
import script from "./wonderfulPVTitle.vue?vue&type=script&lang=js"
export * from "./wonderfulPVTitle.vue?vue&type=script&lang=js"
import style0 from "./wonderfulPVTitle.vue?vue&type=style&index=0&id=1639a948&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1639a948",
  null
  
)

export default component.exports